import { Button, Grid, TextField } from '@mui/material'
import React from 'react'
import { useState } from 'react'
import SubCard from 'ui-component/cards/SubCard'

const data = [
    {
        id: 'code',
        name: 'Vendor Code',
        type: 'text'
    },
    {
        id: 'brand_name',
        name: 'Vendor Name/ID',
        type: 'text'
    },
    {
        id: 'model_number',
        name: 'Company Name',
        type: 'text'
    },
    {
        id: 'device_category',
        name: 'Pan Card No',
        type: 'text'
    },
    {
        id: 'vendor',
        name: 'Mobile No.',
        type: 'text'
    },
    {
        id: 'description',
        name: 'Email ID',
        type: 'text'
    },
    {
        id: 'remarks',
        name: 'Address',
        type: 'text'
    },
    {
        id: 'remarks',
        name: 'Pin Code',
        type: 'text'
    },
    {
        id: 'remarks',
        name: 'State',
        type: 'text'
    },
    {
        id: 'remarks',
        name: 'District',
        type: 'text'
    },
    {
        id: 'remarks',
        name: 'Sub District',
        type: 'text'
    },
    {
        id: 'remarks',
        name: 'City / Town',
        type: 'text'
    },
    {
        id: 'remarks',
        name: 'GST NO',
        type: 'text'
    },
    {
        id: 'remarks',
        name: 'SAC NO',
        type: 'text'
    },
    {
        id: 'remarks',
        name: 'HSN NO',
        type: 'text'
    },
    {
        id: 'remarks',
        name: 'Bank Name',
        type: 'text'
    },
    {
        id: 'remarks',
        name: 'Bank A/C Name',
        type: 'text'
    },
    {
        id: 'remarks',
        name: 'Bank A/C Number',
        type: 'text'
    },
    {
        id: 'remarks',
        name: 'IFSC Code',
        type: 'text'
    },
]



const AddForm = (props) => {
    const [Input, setInput] = useState({})
    const handleChange = (name, value) => {
        setInput({
            ...Input,
            [name]: value
        })
    }
    return (
        <SubCard>
            <Grid container gap={5} justifyContent='space-between'>
                {

                    data.map((item, index) => {
                        return (
                            item.type === 'text' ?

                                <Grid item xl={3} md={4} sm={12} key={index}>
                                    <TextField label={item.name} onChange={(e) => { handleChange(item.id, e.target.value) }} fullWidth />
                                </Grid>
                                :
                                <Grid item xl={6} md={6} sm={12} key={index}>
                                    <TextField multiline label={item.name} onChange={(e) => { handleChange(item.id, e.target.value) }} fullWidth />
                                </Grid>
                        )

                    }

                    )
                }
            </Grid>
            <Grid container mt={2} justifyContent='flex-end'>
                <div style={{display:'flex',alignItems:'center',gap:'50px'}}>
                    <Grid item xl={3}>
                        <Button variant='contained' color='secondary'>Save</Button>
                    </Grid>
                    <Grid item xl={3}>
                        <Button variant='outlined' color='secondary' onClick={()=>props.setAdd(false)}>cancel</Button>
                    </Grid>
                </div>
            </Grid>
        </SubCard>
    )
}

export default AddForm
